const fadlElzikrData = {
  brand: "فضل الذكر",
  List: [
    {
      id: 1,
      title: "فضل كلمة التوحيد",
      text: [
        "عن أبي هريرة رضي الله عنه قال: قال رسول الله: من قال: لا إله إلا الله وحده لا شريك له، له الملك وله الحمد وهو على كل شيء قدير، مائة مرة في يوم كانت له عدل عشر رقاب وكتبت له مائة حسنة ومُحيت عنه مائة سيئة وكانت له حرزاً من الشيطان يومه ذلك حتى يمسي ولم يأت أحد بأفضل مما جاء به إلا أحد عمل أكثر من ذلك. متفق عليه",
        "عن أبي أيوب الأنصاري رضي الله عنه قال: قال رسول الله : من قال: لا إله إلا الله وحده لا شريك له، له الملك وله الحمد وهو على كل شيء قدير عشر مرات كان كمن أعتق أربعة أنفس من ولد إسماعيل. رواه مسلم",
      ],
    },
    {
      id: 2,
      title: "فضل الإستغفار",
      text: [
        "عن بلال بن يسار بن زيد مولى رسول الله عن أبيه أنه سمع النبي يقول: من قال: أستغفر الله العظيم الذي لا إله إلا هو الحي القيوم وأتوب إليه غفر الله ذنوبه وإن كان فر من الزحف. رواه الترمذي وصححه الألباني",
      ],
    },
    {
      id: 3,
      title: "فضل الربوبية",
      text: [
        "عن أبي سعيد الخدري رضي الله عنه أن رسول الله قال:من قال: رضيت بالله رباً وبالإسلام ديناً وبمحمد رسولاً وجبت له الجنة. رواه أبو داوود وصححه الألباني",
      ],
    },
    {
      id: 4,
      title: "فضل سيد الإستغفار",
      text: [
        "عن شداد بن أوس رضي الله عنه قال: قال رسول الله :سيد الإستغفار أن يقول العبد: اللهم أنت ربي لا إله إلا أنت خلقتني وأنا عبدك وأنا على عهدك ووعدك ما استطعت أعوذ بك من شر ما صنعت أبوء بنعمتك عليّ وأبوء بذنبي فاغفر لي فإنه لا يغفر الذنوب إلا أنت. من مات يومه وقد قالها دخل الجنه. رواه البخاري    ",
      ],
    },
    {
      id: 4,
      title: `فضل الدعاء بعد الوضوء`,
      text: [
        `عن عمر بن الخطاب رضي الله عنه قال: قال رسول الله : { من قال بعد الوضوء: أشهد أن لا إله إلا الله وحده لا شريك له، وأشهد أن محمداً عبده ورسوله فُتحت له أبواب الجنة الثمانية يدخل من أيها شاء }[رواه مسلم].`,
      ],
    },
    {
      id: 4,
      title: `فضل التسبيح والتحميد والتكبير`,
      text: [
        `عن أبي هريرة رضي الله عنه قال: قال رسول الله : { من قال بعد كل صلاة: سبحان الله ثلاثاً وثلاثين، والحمد له ثلاثاً وثلاثين، والله أكبر ثلاثاً وثلاثين، وقال تمام المائة: لا إله إلا الله وحده لا شريك له له الملك وله الحمد وهو على كل شيء قدير غفرت ذنوبه وإن كانت مثل زبد البحر } [رواه البخاري].`,
        `عن أبي هريرة رضي الله عنه قال: قال رسول الله : { كلمتان خفيفتان على اللسان ثقيلتان في الميزان حبيبتان إلى الرحمن: سبحان الله وبحمده سبحان الله العظيم } [رواه مسلم].`,
        `عن سعد بن أبي وقاص رضي الله عنه قال: قال رسول الله : { أيعجز أحدكم أن يكسب كل يوم ألف حسنة }. فسأل سائل من جلسائه: كيف يكسب أحدنا ألف حسنة؟ قال: { يسبح مائة تسبيحة فيكتب له ألف حسنة؟ أو يحط عنه ألف خطيئة } [رواه مسلم].`,
        `عن جويرية بنت الحارث أن رسول الله خرج من عندها بكرة حين صلى الصبح وهي في مسجدها ثم رجع بعد أن أضحى وهي جالسة فقال: { ما زلت على الحال التي فارقتك عليها؟ } قالت: نعم. قال: { لقد قلت بعدك أربع كلمات ثلاث مرات لو وزنت بما قلت منذ اليوم لوزنتهن: سبحان الله وبحمده عدد خلقه ورضا نفسه وزنة عرشه ومداد كلماته } [رواه مسلم].`,
        `عن أبي هريرة رضي الله عنه أنه قال: قال رسول الله : { من قال: سبحان الله وبحمده في يوم مائة مرة حطت خطاياه ولو كانت مثل زبد البحر } [رواه مسلم].`,
        `وعنه قال: قال رسول الله : { لأن أقول: سبحان الله والحمد لله ولا إله إلا الله والله أكبر أحب إليّ مما طلعت عليه الشمس } [رواه مسلم].`,
      ],
    },
    {
      id: 4,
      title: `فضل السنن الرواتب`,
      text: [
        `عن أم حبيبة رضي الله عنها قالت: قال رسول الله : { من صلّى لله ثنتي عشرة ركعة تطوعاً بنى الله له بيتاً في الجنة } [رواه مسلم].`,
        `وعنها رضي الله عنها قالت: قال رسول الله : { من صلى قبل الظهر أربعاً وبعدها أربعاً حرمه الله على النار } [رواه الترمذي وصححه الألباني].`,
      ],
    },
    {
      id: 4,
      title: `فضل الدعاء عند دخول السوق`,
      text: [
        `عن عمر بن الخطاب رضي الله عنه قال: قال رسول الله : { من قال حين يدخل السوق: لا إله إلا الله وحده لا شريك له له الملك وله الحمد يحيي ويميت وهو حي لا يموت بيده الخير كله وهو على كل شيء قدير كتب الله له ألف ألف حسنة ووضع عنه ألف ألف سيئة وبنى له بيتاً في الجنة } [رواه الترمذي وصححه الألباني].`,
      ],
    },
    {
      id: 4,
      title: `فضل السعي على الأرملة والمساكين`,
      text: [
        `عن أبي هريرة رضي الله عنه قال: قال رسول الله : { الساعي على الأرملة والمسكين كالمجاهد في سبيل الله }. وأحسبه قال: { وكالقائم لا يفتر } [رواه مسلم]. `,
      ],
    },
    {
      id: 4,
      title: `فضل كفالة اليتيم`,
      text: [
        `عن أبي هريرة رضي الله عنه قال: قال رسول الله : { كافل اليتيم له أو لغيره أنا وهو كهاتين في الجنة }. وأشار بأصبعيه السبابة والوسطى [رواه مسلم].`,
      ],
    },
    {
      id: 4,
      title: `فضل لا حول ولا قوة إلا بالله`,
      text: [
        `عن أبي موسى الأشعري رضي الله عنه قال: قال رسول الله : { يا أبا موسى ألا أدلك على كنز من كنوز الجنة؟ } قال: بلى. قال:{ لا حول ولا قوة إلا بالله } [رواه مسلم].`,
      ],
    },
    {
      id: 4,
      title: ` فضل التوبة`,
      text: [
        `عن أنس رضي الله عنه قال: قال رسول الله : { لله أشد فرحاً بتوبة عبده حين يتوب إليه من أحدكم كان على راحلته بأرض فلاة فانفلتت منه وعليها طعامه وشرابه، فأيس منها فأتى شجرة فاضطجع في ظلها قد أيس من راحلته، فبينا هو كذلك إذ بها قائمة على رأسه فأخذ بخطامها ثم قال: اللهم أنت عبدي وأنا ربك أخطأ من شدة الفرح } [روه مسلم].`,
      ],
    },
    {
      id: 4,
      title: `فضل الدعاء بعد الركوع`,
      text: [
        `عن أنس بن مالك رضي الله عنه: أن رجلاً جاء فدخل الصف وقد حفزه النفس فقال: { الحمد لله حمداً كثيراً طيباً مباركاً فيه } فلما قضى رسول الله صلاته قال: { أيكم المتكلم؟ } فأرم القوم ( أي سكتوا ) فقال: { أيكم المتكلم فإنه لم يقل بأساً }. فقال رجل: جئت وقد حفزني النفس فقلتها. فقال : { لقد رأيت بضعة وثلاثين ملكاً يبتدرونها أيهم يرفعها } [رواه مسلم]. `,
      ],
    },
    {
      id: 4,
      title: `فضل الصلاة على النبي`,
      text: [
        `عن أبي هريرة رضي الله عنه قال: قال رسول الله : { من صلّى عليّ صلاة واحدة صلّى الله عليه بها عشراً } [رواه مسلم]. فضل قراءة آية الكرسي بعد الصلاة 23- عن أبي هريرة رضي الله عنه أن رسول الله قال: { من قرأ آية الكرسي دبر كل صلاة لم يمنعه من دخول الجنة إلا أن يموت }
      `,
      ],
    },
    {
      id: 4,
      title: `فضل سنة الفجر`,
      text: [
        `عن عائشة رضي الله عنها أن رسول الله قال: { ركعتا الفجر خير من الدنيا وما فيها } [رواه مسلم].`,
      ],
    },
    {
      id: 4,
      title: ` فضل الشهادتين والإخلاص فيهما `,
      text: [
        `عن معاذ بن جبل رضي الله عنه أن رسول الله قال: { ما من أحد يشهد أن لا إله إلا الله وأن محمداً رسول الله صدقاً من قلبه إلا حرمه الله على النار } [رواه البخاري]. `,
      ],
    },
    {
      id: 4,
      title: `فضل الإستغفار لعامة المؤمنين`,
      text: [
        `عن عبادة بن الصامت رضي الله عنه قال: سمعت رسول الله يقول: { من استغفر للمؤمنين والمؤمنات كتب الله له بكل مؤمن ومؤمنة حسنة } [رواه الطبراني وحسنه الألباني].`,
      ],
    },
    {
      id: 4,
      title: ` فضل صلة الرحم`,
      text: [
        `عن أبي هريرة رضي الله عنه قال: سمعت رسول الله يقول: { من سرّه أن يُبسط له في رزقه وأن ينسأ له في أثره فليصل رحمه } [متفق عليه].`,
      ],
    },
    {
      id: 4,
      title: `فضل تعلم العلم وتعليمه`,
      text: [
        `عن أمامة رضي الله عنه عن النبي قال: { من غدا إلى المسجد لا يريد إلا أن يتعلم خيراً أو يعلمه كان له كأجر حاجٍ تاماً حجته }[رواه الطبراني وقال: صحيح على شرط الشيخين وصححه الألباني].`,
      ],
    },
    {
      id: 4,
      title: `فضل سورة الإخلاص
`,
      text: [
        `عن أبي الدرداء رضي الله عنه عن النبي قال: { أيعجز أحدكم أن يقرأ ثلث القرآن في ليلة؟ قال: قُلْ هُوَ اللَّهُ أَحَدٌ تعدل ثلث القرآن } [رواه مسلم].`,
      ],
    },
  ],
};

export default fadlElzikrData;
